import type { ApiResponse } from '@shared/types'
import { baseService } from 'v2/shared/services/base-services'
import type { BuddyFeedbackReason } from './buddy-stream'
import type { BuddyUserContext } from './use-buddy-chat'

// 1 = thumbs up.
export type BuddyFeedbackScore = 0 | 1

export interface BuddyFeedbackBody {
  // Minted once per prompt, so a retried vote is idempotent server-side.
  feedback_id: string
  session_id: string
  feedback_type: 'thumbs'
  score: BuddyFeedbackScore
  trigger: BuddyFeedbackReason
  api_id: string | null
  source: 'console'
  userContext: BuddyUserContext
}

export interface RBuddyFeedback {
  feedback_id: string
}

// baseService is the same regional gateway the chat streams from (resolveBaseUrl).
export const submitBuddyFeedback = (body: BuddyFeedbackBody) =>
  baseService.post<ApiResponse<RBuddyFeedback>>('/v1/aiassist/buddy/feedback', body)
